import React, { useState } from 'react';
import 'react-image-lightbox/style.css'; // Importa lo stile del lightbox
import Lightbox from 'react-image-lightbox';
import { Layout } from 'antd';
import '../styles/CoursePlanPage.css'; // Importa il tuo CSS personalizzato

const { Content } = Layout;

const CoursePlanPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const imageUrl = '../images/Plan-corsi.jpeg'; // Percorso dell'immagine del piano dei corsi

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ textAlign: 'center', padding: '20px' }}>
      <div className="dashboard-title">
                    PIANO DEI CORSI
                </div>
        <img
          src={imageUrl}
          alt="Piano dei Corsi"
          style={{ maxWidth: '100%', maxHeight: '80vh', cursor: 'pointer', objectFit: 'contain' }}
          onClick={() => setIsOpen(true)} // Apre il lightbox al click
        />
        <p class="enlarge-instruction">Fai clic sull'immagine per ingrandire.</p>
        
        {isOpen && (
          <Lightbox
            mainSrc={imageUrl}
            onCloseRequest={() => setIsOpen(false)} // Chiude il lightbox
            imageCaption="Piano dei Corsi"
            style={{paddingtop: '50px'}}
          />
        )}
      </Content>
    </Layout>
  );
};

export default CoursePlanPage;
